import { H1 } from '../../components';

export default function PageHeading(props: any) {
  return <H1 typoStyle="xxl" mt="lg" mb="sm" {...props} />;
}
